export const onGetTitle = async (openId, $createAuth, $md5,$http, $url)=> {
  let openTitle = []
  let openTitleStr = localStorage.getItem('openTitle');
  let title = '';
  if (openTitleStr && openTitleStr != 'null') {
    openTitle = JSON.parse(openTitleStr)
    openTitle.forEach((obj, index) => {
      // 在这里执行其他需要对每个对象执行的操作
      if (openId === obj.openId) {
        title = obj.title;
      }
    });

    if (title) {
      document.title = title
    } else {
      let auth = $createAuth($md5);
      let result = await $http.get('/eyeHealth/wxUserChatController/getTitle', {
        openId,
        auth: auth.code,
        time: auth.time
      })
      if (result.message === 'Error: Miss auth parameter.') {
        onGetTitle();
      } else {
        title = result.data.title;
      }
      let objResult = { 'openId': openId, 'title': title }
      openTitle.push(objResult)
      localStorage.setItem('openTitle', JSON.stringify(openTitle))
    }
  } else {
    let auth = $createAuth($md5);
    let result = await $http.get('/eyeHealth/wxUserChatController/getTitle', {
      openId: this.openId,
      auth: auth.code,
      time: auth.time
    })
    if (result.message === 'Error: Miss auth parameter.') {
      onGetTitle();
    } else {
      title = result.data.title;
    }
    let objResult = { 'openId': openId, 'title': title }
    openTitle = []
    openTitle.push(objResult)
    localStorage.setItem('openTitle', JSON.stringify(openTitle))
  }
  document.title = title
}

export const onSetShow = (obj, arr,val) => {
  let isShow = false;
  let special = val || ''
  arr.forEach((item) => {
    isShow = isShow || (obj[item]!= null && obj[item] != '' && obj[item] != special)
  })
  return isShow;
}

export const lineAgeList = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];

export const formatList = (list, agelist, type) => {
  const len = agelist.length;
  const len1 = list.length;
  const arr = new Array(len);
  const arr1 = new Array(len);
  const arrStandard = new Array(len);

  for (let loop = 0; loop < len; loop++) {
    let age = agelist[loop];
    arr[loop] = ''
    arr1[loop] = ''
    // arrStandard[loop] = ''
    for (let loop1 = 0; loop1 < len1; loop1++) {
      let obj = list[loop1];
      if (obj.age == age) {
        if (obj.standard != null && obj.standard != '') {
          arrStandard.push(obj.standard)
        }else if(obj.standard == 0 && (type == 3 || type == 4)){
          arrStandard.push('0.00')
        }
        if (obj.standard1 != null && obj.standard1 != '') {
          arrStandard.push( obj.standard1)
        }
        if (obj.standard2 != null && obj.standard2 != '') {
          arrStandard.push( obj.standard2)
        }
        if (type == 1) arr[loop] = obj.rightNakedFar
        if (type == 2) arr[loop] = obj.leftNakedFar
        if (type == 3) arr[loop] = obj.rightBallSe
        if (type == 4) arr[loop] = obj.leftBallSe
        if (type == 5) arr[loop] = obj.rightPressure
        if (type == 6) arr[loop] = obj.leftPressure
        if (type == 7) {
          if (obj.checkDate != null && obj.checkDate != '') {
            if (obj.rightAxialLength && obj.rightAxialLength != null && obj.rightAxialLength != '') {
              arr[loop] = obj.rightAxialLength
            }
            for (let loop2 = 0; loop2 < loop; loop2++) arr1[loop2] = ''
            if (obj.rightAxialLength && obj.rightAxialLength != null && obj.rightAxialLength != '') {
              arr1[loop] = obj.rightAxialLength
            }
          } else {
            arr1[loop] = obj.rightAxialLength
          }
        }
        if (type == 8) {
          if (obj.checkDate != null && obj.checkDate != '') {
            if (obj.leftAxialLength && obj.leftAxialLength != null && obj.leftAxialLength != '') {
              arr[loop] = obj.leftAxialLength
            }
            for (let loop2 = 0; loop2 < loop; loop2++) arr1[loop2] = ''
            if (obj.leftAxialLength && obj.leftAxialLength != null && obj.leftAxialLength != '') {
              arr1[loop] = obj.leftAxialLength
            }
          } else {
            arr1[loop] = obj.leftAxialLength
          }
        }
        if (type == 9) {
          arr[loop] = obj.rightFirstBut
          arr1[loop] = obj.checkDate
        }
        if (type == 10) {
          arr[loop] = obj.leftFirstBut
          arr1[loop] = obj.checkDate
        }
        if (type == 11) {
          arr[loop] = obj.rightAvgBut
          arr1[loop] = obj.checkDate
        }
        if (type == 12) {
          arr[loop] = obj.leftAvgBut
          arr1[loop] = obj.checkDate
        }
      }
    }
  }
  
  
  return { arr, arr1, arrStandard };
}
export const setMinOrMax= (source, dataArr, type)=> {
  let value = source;
  if (dataArr && dataArr != [] && dataArr.length > 0) {
    dataArr.forEach(item => {
      if (type == 'min') {
        if (Array.isArray(item)) {
          item.forEach(iitem => {
            if (iitem && Number(iitem) < value) value = Math.floor(iitem) - 1;
          })
        }else {
          if (item &&  Number(item) < value) value = Math.floor(item) - 1;
        }
        
      }
      if (type == 'max') {
        if (Array.isArray(item)) {
          item.forEach(iitem => {
            if (iitem && Number(iitem) > value) value = Math.ceil(iitem);
          })
        } else {
        if (item && Number(item) > value) value = Math.ceil(item);

        }
      }
    });
  }
  return value;
}
export const setLineOption = (id, rightData, leftData, sourceMin, sourceMax, xData, avg, arrStandard, yName, otherName, xName, formatY) => {
  const color = ['#5b9bd5', '#ff9933', '#cc9933', '#ff0000'];
  let lineData = [];
  const min = setMinOrMax(sourceMin, [...rightData, ...leftData], 'min');
  const max = setMinOrMax(sourceMax, [...rightData, ...leftData], 'max');
  const nameArr = otherName ? otherName : ['平均', '右眼', '左眼'];
  
  // Standard reference value logic - match exam.js implementation
  let standData = [];
  for(let loop=0; loop<arrStandard.length; loop++){
      let obj = arrStandard[loop];
      if(obj!=null && obj!='') {
        standData.push({yAxis: obj})
      }
  }
  
  if (!otherName) {
    lineData = [];
    lineData.push({
      name: '右眼',
      type: 'line',
      data: rightData,
      smooth: true,
      connectNulls: true, // 连接空值
      smooth: true,
      connectNulls: true, // 连接空值
      itemStyle: {
        borderWidth: 2,    // 边框宽度，值越大线条越粗
      },
      symbolSize: 10,
      areaStyle: {
        origin: 'start',
            color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                    { offset: 0, color: 'rgba(89, 192, 103, 0.3)' },
                    { offset: 1, color: 'rgba(89, 192, 103, 0.02)' }
                ],
                global: false
            }
        },
      color: '#39A6F1',
      markLine: {
        silent: true,
        data: standData,
        lineStyle: {
          normal: { type: 'dashed', color: '#ff9933' }
        }
      }
    });
    lineData.push({
      name: '左眼',
      type: 'line',
      data: leftData,
      smooth: true,
      connectNulls: true, // 连接空值
      itemStyle: {
        borderWidth: 2,    // 边框宽度，值越大线条越粗
      },
      symbolSize: 10,
      areaStyle: {
        origin: 'start',
            color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                    { offset: 0, color: 'rgba(89, 192, 103, 0.3)' },
                    { offset: 1, color: 'rgba(89, 192, 103, 0.02)' }
                ],
                global: false
            }
        },
      color: '#59C067',
      markLine: {
        silent: true,
        data: standData,
        lineStyle: {
          normal: { type: 'dashed', color: '#ff9933' }
        }
      }
    });
  } else {
    rightData.forEach((item, index) => {
      lineData.push({
        name: nameArr[index],
        type: 'line',
        data: item,
        smooth: true,
        connectNulls: true, // 连接空值
        symbolSize: 10,
        itemStyle: {
          borderWidth: 2,    // 边框宽度，值越大线条越粗
        },
        areaStyle: {
          origin: 'start',
            color: { 
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                    { offset: 0, color: 'rgba(89, 192, 103, 0.3)' },
                    { offset: 1, color: 'rgba(89, 192, 103, 0.02)' }
                ],
                global: false
            }
        },
        color: color[index],
        markLine: {
          silent: true,
          data: standData,
          lineStyle: {
            normal: { type: 'dashed', color: '#ff9933' }
          }
        }
      });
    });
  }
  let interval = 1;
  if (id == 'chart' || id == 'chart11') interval = 0.2;
  let paddingSet = [0, 0, 0, -11];
  if (id == 'chart2' || id == 'chart12') {
    paddingSet = [0, 0, 0, 8];
  }
  if (id == 'chart3' || id == 'chart13') {
    paddingSet = [0, 0, 0, 22];
  }
  if (id == 'chart4' || id == 'chart14') {
    paddingSet = [0, 0, 0, 10];
  }
  let legendOpt = {
    icon: 'path://M0,7 L20,7 A3,3 0 0 1 23,10 L23,17 A3,3 0 0 1 20,20 L0,20 A3,3 0 0 1 -3,17 L-3,10 A3,3 0 0 1 0,7 Z',
    itemWidth: 20,  // 长方形宽度
    itemHeight: 16, // 长方形高度
    // 可根据需要调整其他样式
    itemGap: 15,    // 图例项之间的距离
    textStyle: {
      fontSize: 12
    },
    show: true,
    right: '5%',
    top: '6%',
  }
  if (id == 'chart5' || id == 'chart6') {
    legendOpt = {
      icon: 'path://M0,7 L20,7 A3,3 0 0 1 23,10 L23,17 A3,3 0 0 1 20,20 L0,20 A3,3 0 0 1 -3,17 L-3,10 A3,3 0 0 1 0,7 Z',
      itemWidth: 20,  // 长方形宽度
      itemHeight: 16, // 长方形高度
      // 可根据需要调整其他样式
      itemGap: 15,    // 图例项之间的距离
      textStyle: {
        fontSize: 12
      },
    }
  }

  let xPosition = [];
  if (sourceMin > 0) xPosition = [75, 0, 0, -40];
  if (sourceMin<0 && sourceMin > -10) xPosition = [420, 0, 0, -40];
  if (sourceMin < -10) xPosition = [600, 0, 0, -40];
  let option = {
    grid: {
      left: '15%',  // 增加左侧间距（默认10%）
    },
    tooltip: {
      trigger: 'axis',
      //  formatter 函数，自定义提示框内容
      formatter: function (params) {
          // 处理 x 轴数据，把单纯数字转成 “数字 + 岁”
          const xValue = ['chart','chart2','chart3','chart4','chart5','chart6'].includes(id) ? `${params[0].axisValue} 岁` : params[0].axisValue; 

          let result = `${xValue}<br/>`;
          params.forEach((item) => {
              result += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
          });
          return result;
      }
    },
    legend: legendOpt,
    xAxis: {
      type: 'category',
      boundaryGap: false,
      nameLocation: 'end',
      data: xData,
      name: xName || '年龄(岁)',
      nameTextStyle: {        
        fontSize: 12,
        padding: xPosition,
        color: '#999'
      },
      axisLabel: {
        color: '#666'
      },
      axisLine: {
        lineStyle: {
          color: '#ccc',
          width: 1,
          type: 'dashed'
        }
      },
    },
    yAxis: {
      type: 'value',
      min: min,
      max: max,
      name: yName,
      interval,
      nameTextStyle: {        //坐标轴名称的文字样式
        fontSize: 12,
        padding: [35, 10, 0, -5],
        color: '#999'
      },
      axisLabel: {
        formatter: function (value) {
          if (['chart2', 'chart12', 'chart5', 'chart6'].includes(id)) {
                return value.toFixed(2);
              }
          return formatY ? value.toFixed(1) : value;
        },
        
        color: '#666',
      },

      axisLine: {
        lineStyle: {
          color: '#ccc',
          width: 1,
          type: 'dashed'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#ddd'
        }
      }
    },
    series: lineData,
  };
  return option;
}
export const setDateChartData = (data, index)=>{
  if (data != null && data != '') {
    if (index == 0 && data[0] != null && data[0] != '' && data[0].eyeChartNames != null) {
      data[0] = sortData(data[0], 'eyeChartNames', 'leftEyeChartValues', 'rightEyeChartValues')
      if (data[0] != null && data[0] != '') {
        let rightData1 = [...data[0]['rightEyeChartValues'], ...data[0]['rightEyeChartValues2'], ...data[0]['rightEyeChartValues3']];
        let leftData1 = [...data[0]['leftEyeChartValues'], ...data[0]['leftEyeChartValues2'], ...data[0]['leftEyeChartValues3']];
        if (rightData1.length > 0) {
          rightData1.forEach((item, index) => {
            rightData1[index] = item ? parseFloat(item).toFixed(1) : item;
          })
        }
        if (leftData1.length > 0) {
          leftData1.forEach((item, index) => {
            leftData1[index] = item ? parseFloat(item).toFixed(1) : item;
          })
        }
        return {rightData: rightData1, leftData: leftData1 }
      }
    }
    if (index == 1 && data[1] != null && data[1] != '' && data[1].eyeChartNames != null) {
      data[1] = sortData(data[1], 'eyeChartNames', 'leftEyeChartValues', 'rightEyeChartValues')
      if (data[1] != null && data[1] != '') {
        let leftData2 = [...data[1]['leftEyeChartValues'], ...data[1]['leftEyeChartValues2'], ...data[1]['leftEyeChartValues3']]
        let rightData2 = [...data[1]['rightEyeChartValues'], ...data[1]['rightEyeChartValues2'], ...data[1]['rightEyeChartValues3']]
        return {rightData: rightData2, leftData: leftData2 }
      }
      
    }

    if (index == 2 && data[2] != null && data[2] != '' && data[2].eyeChartNames != null) {

      data[2] = sortData(data[2], 'eyeChartNames', 'leftEyeChartValues', 'rightEyeChartValues')
      if (data[2] != null && data[2] != '') {
        let leftData3 = [...data[2]['leftEyeChartValues'], ...data[2]['leftEyeChartValues2'], ...data[2]['leftEyeChartValues3']]
        let rightData3 = [...data[2]['rightEyeChartValues'], ...data[2]['rightEyeChartValues2'], ...data[2]['rightEyeChartValues3']]
    
        return {rightData: rightData3, leftData: leftData3 }
      }
    }
    if (index == 3 && data[3] != null && data[3] != '' && data[3].eyeChartNames != null) {
      data[3] = sortData(data[3], 'eyeChartNames', 'leftEyeChartValues', 'rightEyeChartValues')
      if (data[3] != null && data[3] != '') {
        let leftData4 = [...data[3]['leftEyeChartValues'], ...data[3]['leftEyeChartValues2'], ...data[3]['leftEyeChartValues3']]
        let rightData4 = [...data[3]['rightEyeChartValues'], ...data[3]['rightEyeChartValues2'], ...data[3]['rightEyeChartValues3']]
        
        return {rightData: rightData4, leftData: leftData4 }
      }
    }
  }
}
export const sortData = (obj, eyeChartNames, leftEyeChartValues, rightEyeChartValues)=> {
  if (obj != null && obj != '' && obj[eyeChartNames] != null) {
    let obj1 = obj[eyeChartNames];
    let obj2 = obj[leftEyeChartValues];
    let obj3 = obj[rightEyeChartValues];
    let len = obj1 == null || obj1 == '' ? 0 : obj1.length;
    if (len > 0) {
      let obj4 = new Array();
      for (let loop = 0; loop < len; loop++) {
        obj4[loop] = { val1: obj1[loop], val2: obj2[loop], val3: obj3[loop] }
      }
      obj4.sort(function (a, b) {
        if (a.val1 > b.val1)
          return 1;
        else if (a.val1 < b.val1)
          return -1;
        else
          return 0;
      })
      let loopEnd = 0;
      let obj5 = [];
      let obj6 = [];
      let obj7 = [];
      for (let loop = 0; loop < obj4.length; loop++) {
        if (obj4[loop].val1 != '') {
          obj5[loopEnd] = obj4[loop].val1
          obj6[loopEnd] = obj4[loop].val2
          obj7[loopEnd] = obj4[loop].val3
          loopEnd++
        }
      }
      obj[eyeChartNames] = obj5;
      obj[leftEyeChartValues] = obj6;
      obj[rightEyeChartValues] = obj7;
    }
  }
  return obj
}